<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑分机构</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="24" class="item">
                        <div class="label">机构名称：{{editSonForm.name}}</div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" class="item">
                        <el-tree
                                :data="listInstitutionAll"
                                show-checkbox
                                default-expand-all
                                node-key="institutionCode"
                                ref="tree"
                                highlight-current
                                :props="defaultProps">
                        </el-tree>
                    </el-col>
                </el-row>


            </div>

            <div class="modal-footer">
                <el-button type="primary" @click="confirm()">修改</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    export default {
        name: 'EditSon',
        data() {
            return {

                editSonForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),

                    institutionCode:'',
                    name:'',
                    listSonInstitutionRelDTO:null,
                },

                listInstitutionAll:null,
                defaultProps: {
                    children: 'listInstitutionAll',
                    label: 'name'
                },


            }
        },

        methods: {
            init(row){
                console.log('Edit init');

                this.editSonForm.listSonInstitutionRelDTO = row.listSonInstitutionRelDTO;
                this.editSonForm.institutionCode = row.institutionCode;
                this.editSonForm.name = row.name;

                this.getListInstitution();

            },

            closeSelf() {
                this.$emit("closeEditSon");
            },


            getListInstitution(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/ListSon",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        console.log(response);

                        if (response.data.error == 0) {
                            this.listInstitutionAll = response.data.data.listInstitution;
                            this.checkedNode(this.editSonForm.listSonInstitutionRelDTO);
                        }

                    }
                )

            },


            checkedNode(listSonInstitutionRelDTO){
                let getArr = [];
                for(let i=0;i<listSonInstitutionRelDTO.length;i++){
                    getArr.push(listSonInstitutionRelDTO[i].sonInstitutionCode);
                }
                this.$nextTick(function(){
                    this.$refs.tree.setCheckedKeys(getArr);
                })
            },


            confirm(){


                let nodes = this.$refs.tree.getCheckedNodes(false,true);
                console.log(nodes);

                let arr = [];
                for(let i=0;i<nodes.length;i++){
                    arr.push({"institutionCode":nodes[i].institutionCode});
                }


                this.editSonForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/EditSonInstitution",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        listInstitution: arr,
                        institutionCode:this.editSonForm.institutionCode,
                    }
                }).then(
                    (response) => {
                        console.log(response);

                        if (response.data.error == 0) {
                            this.$emit("closeEditSon");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 300px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
